import React from 'react';
import { AppBar, Box, Button, FormControl, TextField, Typography } from '@mui/material';

import { useAuth } from './AuthContext';
import { useAuthAjax } from './Ajax';

const initialValues = {
    scode: '',
    spass: '',
}

export const LoginForm = () => {
    const { logon } = useAuth();
    const { login:ajaxLogin } = useAuthAjax();

    const refScode = React.useRef(null);
    const refSpass = React.useRef(null);

    React.useEffect(e=>{
        refScode.current?.focus();
    }, []);

    const [ values, setValues ] = React.useState(initialValues)
    const handleChange = (e) => {
        setValues((v)=>({...v, [e.target.name]:e.target.value}));
    }
    const handleKeyDown = (e) => {
        if(e.keyCode === 13 /* e.key === 'Enter' */) {
            e.preventDefault();
            if(e.target.name === 'spass') {
                handleButtonClick();
            } else {
                refSpass.current?.focus();
            }
        }
    }

    const [ errorMessage, setErrorMessage ] = React.useState("");
    const handleButtonClick = ()=> {
        setErrorMessage("");
        // console.log(values);
        ajaxLogin(values.scode, values.spass)
        .then((res)=>{
            // console.log(res.data);
            logon(res.data.id, res.data.scode, res.data.sname, res.data.sauth);
        })
        .catch((err)=>{
            // console.log(err);
            setErrorMessage("職員番号かパスワードが違います。");
            refScode.current?.focus();
        })
    }

    return (
        <Box sx={{display: 'flex', flexDirection: 'column', justifyContent: 'center', height: '90vh'}}>
            <Box sx={{display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>
                <Box sx={{p: 5, display: 'flex', flexDirection: 'column', border: '1px dashed gray', borderRadius: 2}}>
                    <AppBar>
                        <Typography>健診予約表</Typography>
                    </AppBar>
                    <Typography sx={{m:2}} color='red'>{errorMessage}</Typography>
                    <FormControl variant="outlined" sx={{m:2}}>
                        {/* <InputLabel htmlFor="scode">職員番号</InputLabel> */}
                        <TextField label="職員番号" name="scode" value={values.scode} onChange={handleChange} onKeyDown={handleKeyDown} inputRef={refScode}/>
                        {/* <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText> */}
                    </FormControl>
                    <FormControl variant="outlined" sx={{m:2}}>
                        {/* <InputLabel htmlFor="spass">パスワード</InputLabel> */}
                        <TextField label="パスワード" name="spass" value={values.spass} onChange={handleChange} onKeyDown={handleKeyDown} inputRef={refSpass}/>
                        {/* <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText> */}
                    </FormControl>
                    <FormControl sx={{m:2}}>
                        <Button onClick={handleButtonClick} variant="contained">ログイン</Button>
                    </FormControl>
                </Box>
            </Box>
        </Box>
    );
}
